<template>
  <pt-adult-stock-list class="pt-adult-stock-list__withData" :agentOrgs="agentOrgs"></pt-adult-stock-list>
</template>

<script>
import PtAdultStockList from './index'
export default {
  name: 'pt-adult-stock-list__withData',
  components: {
    'pt-adult-stock-list': PtAdultStockList
  },
  data () {
    return {
      agentOrgs: []
    }
  },
  methods: {
    getAgentOrgs () {
      let params = {
        type: 'AGENT',
        businessType: ['ADULT'],
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,asc'] }
      }
      this.$store.dispatch('getBranchCompanyList', params).then(res => {
        this.agentOrgs = res.data.map(ele => {
          return {
            label: ele.fullName,
            value: ele.id
          }
        })
      })
    }
  },
  created () {
    this.getAgentOrgs()
  }
}
</script>
